import React, { useState } from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import styled from 'styled-components';
import StaticIndicatorSections from './StaticIndicatorSections';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { IndicatorDetailsRoutes, SectionIndicators } from './utils';
import IndicatorSections from './IndicatorSections';
import { IndicatorSectionKey } from '../ImpactIndicator/utils';

const FooterHeight = '347px';
const FooterHeaderHeight = '77px';
const FooterContentHeight = '270px'; // 347px - 77px = 270px
const ANIMATION_TIME = '0.8s';
const StyledFooter = styled.footer<{ collapse: boolean }>`
  bottom: 0;
  position: sticky;
  height: ${({ collapse }) => (collapse ? FooterHeaderHeight : FooterHeight)};
  background-color: ${COLORS.whiteBase};
  transition: height ${ANIMATION_TIME} ease;
  .footer-heading {
    display: flex;
    margin-bottom: 0px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 28px;
    font-size: 18px;
    text-align: center;
    background-color: ${COLORS.grayLightest};
    box-shadow: 0px -3px 12px -2px ${COLORS.greyBase};
    svg {
      margin-left: ${SPACERS.tiny};
      transition: transform ${ANIMATION_TIME} ease;
    }
    svg.collapse {
      transform: rotate(-180deg);
    }
  }
`;

interface IndicatorDetailsFooterProps {
  route: IndicatorDetailsRoutes;
  indicators: SectionIndicators;
  selectedSectionKey: IndicatorSectionKey;
  selectedIndex: number;
  hideFooter: boolean;
}

const IndicatorDetailsFooter: React.FC<IndicatorDetailsFooterProps> = ({
  route,
  indicators,
  selectedSectionKey,
  selectedIndex,
  hideFooter,
}) => {
  const [collapse, setCollapse] = useState<boolean>(false);
  const handleClick = () => setCollapse(s => !s);

  // https://trueimpact.atlassian.net/browse/TIPD-1935
  if (hideFooter) return null;

  return (
    <StyledFooter collapse={collapse}>
      <TrueImpactText
        variant="heading-subheading"
        className="footer-heading"
        onClick={handleClick}
      >
        Impact Model Preview
        <FontAwesomeIcon
          icon={faChevronDown}
          className={collapse ? 'collapse' : undefined}
        />
      </TrueImpactText>
      {route === 'intro' ? (
        <StaticIndicatorSections />
      ) : (
        <IndicatorSections
          height={FooterContentHeight}
          selectedIndex={selectedIndex}
          selectedSectionKey={selectedSectionKey}
          indicators={indicators}
        />
      )}
    </StyledFooter>
  );
};

export default IndicatorDetailsFooter;
